<template>
  <b-card no-body class="mt-6">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-colorblue table-textcenter"
      :data="
        c * xCommunity.slice((currentPage - 1) * perPage, currentPage * perPage)
      "
    >
      <el-table-column
        label="Community Name"
        min-width="250px"
        prop="channelName"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-center name mb-0 text-sm">
            {{ row.name }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Post"
        prop="totalPost"
        min-width="130px"
        sortable
      >
        <template v-slot="{ row }">
          <p class="text-center">{{ row.postCount }}</p>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Members"
        prop="totalMember"
        min-width="190px"
      >
        <template v-slot="{ row }">
          <p class="text-center">{{ row.memberCount }}</p>
        </template>
      </el-table-column>

      <el-table-column label="Admins" prop="admins" min-width="140px" sortable>
        <template v-slot="{ row }">
          <p class="text-center">{{ row.adminCount }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Status" min-width="170px" prop="status" sortable>
        <template v-slot="{ row }">
          <p class="text-center">
            <badge class="badge-dot mr-4">
              <i
                :class="`bg-${row.type == 'public' ? 'kotakblue' : 'primary'}`"
              ></i>
              <span class="status text-black">{{ row.type }}</span>
            </badge>
          </p>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="Completion"
        prop="completion"
        min-width="240px"
        sortable
      >
        <template v-slot="{ row }">
          <div class="d-flex align-items-center">
            <span class="completion mr-2">%</span>
            <div>
              <base-progress :type="row.statusType" :value="row.completion" />
            </div>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column min-width="180px">
        <template v-slot="{ row }">
          <el-dropdown trigger="click" class="dropdown">
            <span class="btn btn-sm btn-icon-only text-light">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here</b-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column> -->
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        @change="
          value => {
            currentPage = value;
            dataload();
          }
        "
        :per-page="perPage"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import projects from "./CategoryData";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      projects,
      currentPage: 1,
      channel: [],
      total_row: 1,
      perPage: 5
    };
  },
  methods: {
    async dataload() {
      let limit = this.perPage;

      if ((this.currentPage - 1) * this.perPage > this.channel.length)
        limit = this.currentPage * this.perPage - this.channel.length;

      const offset = this.channel.length;
      if (!this.channel[this.currentPage * this.perPage - 1]) {
        let loader = this.$loading();
        try {
          const result = await this.$store.dispatch("admin/getChannel", {
            offset: offset,
            limit: limit
          });
          this.total_row = this.$store.state.admin.channel.totalCount;
          this.$store.state.admin.channel.result.forEach(data => {
            this.channel[this.channel.length] = data;
          });
          this.channel.push();
          loader.close();
        } catch (error) {
          loader.close();
        }
      }
    }
  },
  mounted: function() {
    this.dataload();
  }
};
</script>
